export default "<md-input-container class=\"md-block\">\n  <label>Text</label>\n  <textarea ng-model=\"Label.item.value\"></textarea>\n</md-input-container>\n";